import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';

import UserSignUp from '../components/user-signup';
import Actions from '../actions';
import UserAPI from '../apis/user';
import APP_ROUTES from '../constants/app-routes';
import translations from '../../translations/app-translations';

const mapStateToProps = (state, ownProps) => ({
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({
    submitSignupForm: (formData, locale) => {
        dispatch(Actions.displayLoader());

        const signupPromise = UserAPI.signup({ data: formData, locale });

        signupPromise.then(
            (response) => {
                dispatch(Actions.hideLoader());
                dispatch(Actions.login(response.body, locale));
                toastr.success(translations[locale].well, translations[locale]['successfully-registered']);
                dispatch(push(APP_ROUTES.homePageRoute));
                // dispatch(Actions.showFlash('Successfully registered'));
            },
            (error) => {
                if (error.response.body.error) {
                    toastr.error(translations[locale].error, error.response.body.error);
                } else {
                    toastr.error(translations[locale].error, translations[locale]['registration-error']);
                }
                dispatch(Actions.logout());
                dispatch(Actions.hideLoader());
            },
        );

        return signupPromise;
    },
});

const UserSignupConnector = connect(mapStateToProps, mapDispatchToProps)(UserSignUp);

export default UserSignupConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/user-signup-connector.js
 **/